// import React from 'react';
// import ReactDOM from 'react-dom';
// // import 'bootstrap/dist/css/bootstrap.css';
// // import 'bootstrap/dist/js/bootstrap.js';
// import App from './App';
// import './index.css';

// ReactDOM.render(
//   <App />,
//   document.getElementById('root')
// );


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AdminContextProvider } from './context/adminContext';


const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
      <AdminContextProvider>
            <App />
      </AdminContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();